module.exports = __webpack_public_path__ + "img/logosCorp.3c6ba8c3.svg";